<template>
    <div :class="[
             'recipient-card',
             {
                 'recipient-card--hover': !isDisabled,
                 'recipient-card--solo': isSolo,
             }
         ]"
        @click="emitAction('recipientSelect', recipient)"
    >
        <img class="image"
            src="@webapp/assets/profile-blank.webp"
        >
        <div class="details">
            <label :class="`details__type details__type--${recipient.type}`">{{ recipient.type }}</label>
            <label class="detail__network">{{ getNetworkLabel(recipient) }}</label>
            <label class="details__name">{{ recipient.label }}</label>
            <label class="details__address"
                @click.stop="copyToClipboard(recipient.blockchainAddress)"
            >
                {{ recipient.blockchainAddress }}
            </label>
        </div>
        <div v-if="!isDisabled"
            class="actions"
        >
            <i class="actions__toggle icon-dots"
                @click.stop="toggleActionMenu"
            />
            <div v-if="showActionMenu"
                class="actions__menu"
            >
                <div v-for="(menuItem, index) in menuItems"
                    :key="index"
                    class="item"
                    @click.stop="emitAction(menuItem.action, recipient)"
                >
                    <i :class="`item__icon icon icon-${menuItem.icon}`" />
                    <label class="item__label">{{ menuItem.label }}</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// Helpers
import {
    copyToClipboard,
} from '@webapp/helpers/generic.js';

export default {
    name: 'recipient-card',
    props: {
        recipient: {
            type: Object,
            default: () => ({}),
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
        isSolo: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showActionMenu: false,
            menuItems: [
                {
                    label: this.$t('sendOut.menu.edit'),
                    icon: 'edit',
                    action: 'edit',
                },
                {
                    label: this.$t('sendOut.menu.delete'),
                    icon: 'remove',
                    action: 'remove',
                },
            ],
        };
    },
    created() {
        this.detectOutsideClick();
    },
    methods: {
        detectOutsideClick() {
            document.addEventListener('click', (e) => {
                if (!e.target.classList.contains('actions__toggle')) {
                    this.showActionMenu = false;
                }
            });
        },
        copyToClipboard(text) {
            if (!this.isDisabled) {
                copyToClipboard(text, this);
            }
        },
        toggleActionMenu() {
            this.showActionMenu = !this.showActionMenu;
        },
        emitAction(action, data) {
            this.$emit(action, data);
            this.showActionMenu = false;
        },
        getNetworkLabel(recipient) {
            if (recipient.network) {
                return recipient.network.label;
            }

            return this.$t(`nft.details.${recipient.tokenOwner.networkType}`);
        },
    },
};
</script>

<style lang="scss" scoped>
.recipient {
    &-card {
        display: flex;
        background: $snow-color;
        border: 0.1rem solid $quartz-color;
        padding: 1.8rem 2.3rem;
        border-radius: 1.2rem;
        margin-bottom: 2rem;

        &--solo {
            margin-bottom: 0;
        }

        &--hover {
            cursor: pointer;

            * {
                cursor: inherit;
            }

            &:hover {
                background: darken($snow-color, 5%);
            }
        }

        .image {
            width: 3.6rem;
            height: 3.6rem;
            border-radius: 50%;
        }

        .details {
            margin-left: 1.7rem;
            display: flex;
            flex-direction: column;
            text-align: left;
            flex-grow: 1;
            margin-right: 6rem;

            @include max-width(sm) {
                margin-right: 2rem;
            }

            &__type {
                font: 700 0.9rem/1em "Nunito";
                padding: 0.4rem 0.8rem;
                border-radius: 0.2rem;
                background-color: $mariner-color;
                width: fit-content;
                color: $white-color;
                margin-bottom: 0.5rem;

                &--exchange {
                    background-color: $ronchi-color;
                }

                &--personal {
                    background-color: $tradewind-color;
                }
            }

            &__network {
                font-size: 1.1rem;
            }

            &__name {
                font: 700 1.6rem/2.2rem "Nunito";
                color: $cyprus-color;
            }

            &__address {
                font-size: 1.5rem;
                border: 0.05rem solid $gainsboro-color;
                border-radius: 0.2rem;
                background: $white-color;
                color: $cyprus-color;
                padding: 0.5rem 1rem;
                margin-top: 2rem;
                width: 0;
                min-width: 100%;
                text-overflow: ellipsis;
                overflow: hidden;
            }
        }

        .actions {
            margin: 0 auto !important;
            position: relative;
            height: 2rem;

            &__toggle {
                color: $cyprus-color;
                font-size: 2rem;
                padding: 0.4rem 1rem;
                display: inline-block;
            }

            &__menu {
                background: $white-color;
                box-shadow: rgba($black-color, 0.1) 0 2rem 2rem 0;
                color: $cyprus-color;
                border-radius: 0.6rem;
                position: absolute;
                right: 0;
                white-space: nowrap;

                .item {
                    display: flex;
                    align-items: center;
                    height: 4.6rem;
                    width: 14.7rem;
                    cursor: pointer;
                    padding: 0 2.74rem;

                    &:hover {
                        background: darken($white-color, 5%);
                    }

                    &:not(:last-child) {
                        border-bottom: 1px solid rgba($silver-color, 0.22);
                    }

                    &__icon {
                        font-size: 1.9rem;
                    }

                    &__label {
                        font-size: 1.2rem;
                        padding-left: 1.3rem;
                    }
                }
            }
        }
    }
}
</style>